import { OriginalClonePair } from '../types';
import { isNodeWithChildren } from './isNodeWithChildren';

export const findTextNodesInCopy = (
  originalNode: BaseNode,
  clonedNode: BaseNode
): OriginalClonePair<TextNode>[] => {
  if (!isNodeWithChildren(originalNode) || !isNodeWithChildren(clonedNode))
    return [];

  const originalNodes = originalNode.findAll(
    (node) => node.type === 'TEXT'
  ) as TextNode[];

  const clonedNodes = clonedNode.findAll(
    (node) => node.type === 'TEXT'
  ) as TextNode[];

  return originalNodes.map((originalNode, index) => ({
    original: originalNode,
    clone: clonedNodes[index],
  }));
};
